import { render, staticRenderFns } from "./BackendCreate.vue?vue&type=template&id=1897c94b&"
import script from "./BackendCreate.vue?vue&type=script&lang=js&"
export * from "./BackendCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports